import React from 'react'
import { Dialog, DialogContent, Grid, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Header from '../Header';
import { useStore } from '../../Store'
import { getErrorProps, getOptions } from '../../utils';

const ObjectDetails = ({ formik, onClose, readonly, open, zomertelling }) => {
  const { settings } = useStore()

  return (
    <Dialog open={open}>
      <Header backAction={onClose} title="Object gegevens" />
      <DialogContent>
        <Grid container>
          {!readonly &&
            <Alert severity="info">
              Geef hieronder de bouwkundige en gebruiksgegevens van het object. Na de eerste registratie hoeven alleen wijzigingen in deze gegevens geregistreerd te worden.
            </Alert>
          }
          <Grid item xs={12}>
            <TextField select disabled={readonly} label="gebruik object" variant="standard" name="objectInfo.gebruik_zolder" fullWidth  {...getErrorProps(formik, "objectInfo.gebruik_zolder")} {...formik.getFieldProps('objectInfo.gebruik_zolder')} >
              {getOptions(settings.lists["gebruik_zolder"])}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField select disabled={readonly} label="klimaat: licht" variant="standard" name="objectInfo.klimaat_licht" fullWidth  {...getErrorProps(formik, "objectInfo.klimaat_licht")} {...formik.getFieldProps('objectInfo.klimaat_licht')} >
              {getOptions(settings.lists["klimaat_licht"])}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField select disabled={readonly} label="vochtigheid" variant="standard" name="objectInfo.klimaat_vocht" fullWidth  {...getErrorProps(formik, "objectInfo.klimaat_vocht")} {...formik.getFieldProps('objectInfo.klimaat_vocht')} >
              {getOptions(settings.lists["klimaat_vocht"])}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField disabled={readonly} multiline label="toelichting wijzigingen" variant="standard" name="extraInfo.toelichting_wijzigingen" fullWidth  {...getErrorProps(formik, "extraInfo.toelichting_wijzigingen")} {...formik.getFieldProps('extraInfo.toelichting_wijzigingen')} />
          </Grid>
          {zomertelling &&
            <>
              <Alert severity="info">
                Hier kunnen aanvullende object gegevens worden opgegeven speciaal voor zomertelling.
              </Alert>
              <Grid item xs={12}>
                <TextField select disabled={readonly} label="gesprek met objecteigenaar" variant="standard" name="objectInfo.gesprek" fullWidth  {...getErrorProps(formik, "objectInfo.gesprek")} {...formik.getFieldProps('objectInfo.gesprek')} >
                  {getOptions(settings.lists["gesprek"])}
                </TextField>
                {formik.values.objectInfo && formik.values.objectInfo.gesprek === 'ja' &&
                  <Grid item xs={12}>
                    <TextField disabled={readonly} multiline label="toelichting wijzigingen" variant="standard" name="extraInfo.toelichting_wijzigingen" fullWidth  {...getErrorProps(formik, "extraInfo.toelichting_wijzigingen")} {...formik.getFieldProps('extraInfo.toelichting_wijzigingen')} />
                  </Grid>
                }
              </Grid>
              <Grid item xs={12}>
                <TextField select disabled={readonly} label="(na-)isolatie" variant="standard" name="objectInfo.isolatie" fullWidth  {...getErrorProps(formik, "objectInfo.isolatie")} {...formik.getFieldProps('objectInfo.isolatie')} >
                  {getOptions(settings.lists["isolatie"])}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField select disabled={readonly} label="openingen dicht gemaakt" variant="standard" name="objectInfo.openingendicht" fullWidth  {...getErrorProps(formik, "objectInfo.openingendicht")} {...formik.getFieldProps('objectInfo.openingendicht')} >
                  {getOptions(settings.lists["openingendicht"])}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField select disabled={readonly} label="andere uitvliegopeningen in gebruik" variant="standard" name="objectInfo.uitvliegopeningen" fullWidth  {...getErrorProps(formik, "objectInfo.andereopeningen")} {...formik.getFieldProps('objectInfo.anderopeningen')} >
                  {getOptions(settings.lists["andereopeningen"])}
                </TextField>
              </Grid>
            </>
          }
        </Grid>
      </DialogContent>
    </Dialog>
  )
};

export default ObjectDetails;
